var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/Details/details.scss";
import SidebarBodyAccordion from "@frameworks/NCD/Components/SidebarBodyAccordion";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useSelector } from "react-redux";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
import moment from "moment";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/DowloadData";
var formatDate = function (date) {
    return date ? moment(date).format("D MMM YYYY, hh:mm:ss A") : "-";
};
var formatCurrency = function (value) {
    return ("\u20B9".concat(addCommasWithoutEffectingDecimals(Number(value).toFixed(2))) || "-");
};
var OrderDetails = function (_a) {
    var _b;
    var subCategory = _a.subCategory;
    var orderBookDetails = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }).orderBookDetails;
    var orderDetailsLocal = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data;
    var isRefund = !["sell", "buy"].includes(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.order_type.toLowerCase());
    var isCancelledRejected = [2].includes(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.refund_type_display_id);
    var isSuspenceRefund = [4].includes(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.refund_type_display_id);
    var isInterestDividend = [3].includes(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.refund_type_display_id);
    var orderDetailsData = function (subCategoryId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
        if (isRefund) {
            return {
                orderDetails: __spreadArray([
                    {
                        section: "Refund Details",
                        icon: (React.createElement("span", { className: "icon" },
                            React.createElement("i", { className: "edel-icon-order-details d-flex" }))),
                        data: [
                            {
                                label: isCancelledRejected || isSuspenceRefund || isInterestDividend
                                    ? isSuspenceRefund
                                        ? "Suspense Amount"
                                        : isCancelledRejected
                                            ? "Amount"
                                            : "Interest/Dividend Amount"
                                    : "Excess Amount",
                                value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.amount),
                            },
                            {
                                label: "Order ID",
                                value: (_a = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.trx_code) !== null && _a !== void 0 ? _a : "-",
                                valueClassName: "RobotoM_14_400",
                            },
                        ],
                    },
                    {
                        section: "Bank Details",
                        icon: (React.createElement("span", { className: "icon" },
                            React.createElement("i", { className: "edel-icon-folded-paper d-flex" }))),
                        data: __spreadArray(__spreadArray([], __read((isCancelledRejected || isSuspenceRefund
                            ? [
                                {
                                    label: "UTR No. / Cheque No.",
                                    value: (_b = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.payment_ref_no) !== null && _b !== void 0 ? _b : "-",
                                    valueClassName: "DMSanN_14_400",
                                },
                            ]
                            : [])), false), [
                            {
                                label: "Bank Name",
                                value: (_c = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_name) !== null && _c !== void 0 ? _c : "-",
                                valueClassName: "DMSanN_14_400",
                            },
                            {
                                label: "IFSC Code",
                                value: (_d = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.ifsc_code) !== null && _d !== void 0 ? _d : "-",
                                valueClassName: "DMSanN_14_400",
                            },
                        ], false),
                    }
                ], __read((!isSuspenceRefund
                    ? [
                        {
                            section: "Product Details",
                            icon: (React.createElement("span", { className: "icon" },
                                React.createElement("i", { className: "edel-icon-order-details d-flex" }))),
                            data: [
                                {
                                    label: "Quantity",
                                    value: (_e = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.quantity) !== null && _e !== void 0 ? _e : "--",
                                },
                                {
                                    label: "Dirty Price",
                                    value: (_f = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dirty_price) !== null && _f !== void 0 ? _f : "--",
                                },
                                {
                                    label: "Accrued Interest",
                                    value: (_g = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest) !== null && _g !== void 0 ? _g : "-",
                                },
                                {
                                    label: "Clean Price",
                                    value: (_h = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.clean_price) !== null && _h !== void 0 ? _h : "-",
                                    valueClassName: "DMSanN_14_400",
                                },
                            ],
                        },
                    ]
                    : [])), false),
            };
        }
        else {
            switch (subCategoryId) {
                case ESubProductIds.NCD:
                    return {
                        orderDetails: [
                            {
                                section: "Order Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-order-details d-flex" })))),
                                data: [
                                    {
                                        label: "Amount",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.amount),
                                    },
                                    {
                                        label: "Price/Quantity",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.price_per_qty),
                                    },
                                    {
                                        label: "Quantity",
                                        value: (_j = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.quantity) !== null && _j !== void 0 ? _j : "-",
                                    },
                                    {
                                        label: "Interest Freq",
                                        value: (_k = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.interest_frequency) !== null && _k !== void 0 ? _k : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Coupon",
                                        value: (_l = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.coupon) !== null && _l !== void 0 ? _l : "-",
                                        valueClassName: "RobotoM_14_400",
                                    },
                                    {
                                        label: "Order ID",
                                        value: (_m = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.trx_code) !== null && _m !== void 0 ? _m : "-",
                                        valueClassName: "RobotoM_14_400",
                                    },
                                    {
                                        label: "Placed On",
                                        value: formatDate(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.str_created_date),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                            {
                                section: "Payment Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-folded-paper d-flex" })))),
                                data: __spreadArray(__spreadArray([], __read(((orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.type) !== EBuySellFlag.BUY.toLowerCase()
                                    ? [
                                        {
                                            label: "Payment Mode",
                                            value: (_o = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.payment_mode) !== null && _o !== void 0 ? _o : "-",
                                            valueClassName: "DMSanN_14_400",
                                        },
                                    ]
                                    : [])), false), [
                                    {
                                        label: "Bank Name",
                                        value: (_p = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_name) !== null && _p !== void 0 ? _p : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Account Number",
                                        value: (_q = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_ac_no) !== null && _q !== void 0 ? _q : "-",
                                    },
                                ], false),
                            },
                            {
                                section: "Price Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-price-details d-flex" })))),
                                data: [
                                    {
                                        label: "Accrued Interest",
                                        value: (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            ? "".concat(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            : "-",
                                    },
                                    {
                                        label: "Clean Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.clean_price),
                                    },
                                    {
                                        label: "Dirty Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dirty_price),
                                    },
                                ],
                            },
                            {
                                section: "Depository Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-depository-details d-flex" })))),
                                data: [
                                    {
                                        label: "DP Name",
                                        value: (_r = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_name) !== null && _r !== void 0 ? _r : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    { label: "DP ID", value: (_s = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_id) !== null && _s !== void 0 ? _s : "-" },
                                ],
                            },
                            {
                                section: "Other Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-other-detail d-flex" })))),
                                data: [
                                    {
                                        label: "SB Name/Passout",
                                        value: "".concat((_t = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.sb_name) !== null && _t !== void 0 ? _t : "-", "/").concat((_u = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) !== null && _u !== void 0 ? _u : "-"),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                        ],
                    };
                case ESubProductIds.Bonds:
                    return {
                        orderDetails: [
                            {
                                section: "Order Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-order-details d-flex" })))),
                                data: [
                                    {
                                        label: "Amount",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.amount),
                                    },
                                    {
                                        label: "Price/Quantity",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.price_per_qty),
                                    },
                                    {
                                        label: "Quantity",
                                        value: (_v = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.quantity) !== null && _v !== void 0 ? _v : "-",
                                    },
                                    {
                                        label: "Interest Freq",
                                        value: (_w = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.interest_frequency) !== null && _w !== void 0 ? _w : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Coupon",
                                        value: (_x = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.coupon) !== null && _x !== void 0 ? _x : "-",
                                    },
                                    {
                                        label: "Order ID",
                                        value: (_y = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.trx_code) !== null && _y !== void 0 ? _y : "-",
                                    },
                                    {
                                        label: "Placed On",
                                        value: formatDate(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.str_created_date),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                            {
                                section: "Payment Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-folded-paper d-flex" })))),
                                data: __spreadArray(__spreadArray([], __read(((orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.type) !== EBuySellFlag.BUY.toLowerCase()
                                    ? [
                                        {
                                            label: "Payment Mode",
                                            value: (_z = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.payment_mode) !== null && _z !== void 0 ? _z : "-",
                                            valueClassName: "DMSanN_14_400",
                                        },
                                    ]
                                    : [])), false), [
                                    {
                                        label: "Bank Name",
                                        value: (_0 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_name) !== null && _0 !== void 0 ? _0 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Account Number",
                                        value: (_1 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_ac_no) !== null && _1 !== void 0 ? _1 : "-",
                                    },
                                ], false),
                            },
                            {
                                section: "Price Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-price-details d-flex" })))),
                                data: [
                                    {
                                        label: "Accrued Interest",
                                        value: (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            ? "".concat(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            : "-",
                                    },
                                    {
                                        label: "Clean Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.clean_price),
                                    },
                                    {
                                        label: "Dirty Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dirty_price),
                                    },
                                ],
                            },
                            {
                                section: "Depository Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-depository-details d-flex" })))),
                                data: [
                                    {
                                        label: "DP Name",
                                        value: (_2 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_name) !== null && _2 !== void 0 ? _2 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    { label: "DP ID", value: (_3 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_id) !== null && _3 !== void 0 ? _3 : "-" },
                                ],
                            },
                            {
                                section: "Other Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-other-detail d-flex" })))),
                                data: [
                                    {
                                        label: "SB Name/Passout",
                                        value: "".concat((_4 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.sb_name) !== null && _4 !== void 0 ? _4 : "-", "/").concat((_5 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) !== null && _5 !== void 0 ? _5 : "-"),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                        ],
                    };
                case ESubProductIds.StructuredProducts:
                    return {
                        orderDetails: [
                            {
                                section: "Order Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-order-details d-flex" })))),
                                data: [
                                    {
                                        label: "Amount",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.amount),
                                    },
                                    {
                                        label: "Price/Quantity",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.price_per_qty),
                                    },
                                    {
                                        label: "Quantity",
                                        value: (_6 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.quantity) !== null && _6 !== void 0 ? _6 : "-",
                                    },
                                    {
                                        label: "Interest Freq",
                                        value: (_7 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.interest_frequency) !== null && _7 !== void 0 ? _7 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Coupon Rate",
                                        value: (_8 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.coupon) !== null && _8 !== void 0 ? _8 : "-",
                                        className: "txt-midnight-blue-shade2",
                                    },
                                    {
                                        label: "Order ID",
                                        value: (_9 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.trx_code) !== null && _9 !== void 0 ? _9 : "-",
                                    },
                                    {
                                        label: "Placed On",
                                        value: formatDate(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.str_created_date),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                            {
                                section: "Payment Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-folded-paper d-flex" })))),
                                data: __spreadArray(__spreadArray([], __read(((orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.type) !== EBuySellFlag.BUY.toLowerCase()
                                    ? [
                                        {
                                            label: "Payment Mode",
                                            value: (_10 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.payment_mode) !== null && _10 !== void 0 ? _10 : "-",
                                            valueClassName: "DMSanN_14_400",
                                        },
                                    ]
                                    : [])), false), [
                                    {
                                        label: "Bank Name",
                                        value: (_11 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_name) !== null && _11 !== void 0 ? _11 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Account Number",
                                        value: (_12 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_ac_no) !== null && _12 !== void 0 ? _12 : "-",
                                    },
                                ], false),
                            },
                            {
                                section: "Price Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-price-details d-flex" })))),
                                data: [
                                    {
                                        label: "Accrued Interest",
                                        value: (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            ? "".concat(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.accured_interest)
                                            : "-",
                                    },
                                    {
                                        label: "Clean Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.clean_price),
                                    },
                                    {
                                        label: "Dirty Price",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dirty_price),
                                    },
                                ],
                            },
                            {
                                section: "Depository Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-depository-details d-flex" })))),
                                data: [
                                    {
                                        label: "DP Name",
                                        value: (_13 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_name) !== null && _13 !== void 0 ? _13 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    { label: "DP ID", value: (_14 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_id) !== null && _14 !== void 0 ? _14 : "-" },
                                ],
                            },
                            {
                                section: "Other Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-other-detail d-flex" })))),
                                data: [
                                    {
                                        label: "SB Name/Passout",
                                        value: "".concat((_15 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.sb_name) !== null && _15 !== void 0 ? _15 : "-", "/").concat((_16 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) !== null && _16 !== void 0 ? _16 : "-"),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                        ],
                    };
                case ESubProductIds.UnlistedShares:
                    return {
                        orderDetails: [
                            {
                                section: "Order Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-order-details d-flex" })))),
                                data: [
                                    {
                                        label: "Amount",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.amount),
                                    },
                                    {
                                        label: "Price/Quantity",
                                        value: formatCurrency(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.price_per_qty),
                                    },
                                    {
                                        label: "Quantity",
                                        value: (_17 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.quantity) !== null && _17 !== void 0 ? _17 : "-",
                                    },
                                    {
                                        label: "Order ID",
                                        value: (_18 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.trx_code) !== null && _18 !== void 0 ? _18 : "-",
                                    },
                                    {
                                        label: "Placed On",
                                        value: formatDate(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.str_created_date),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                            {
                                section: "Payment Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-folded-paper d-flex" })))),
                                data: __spreadArray(__spreadArray([], __read(((orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.type) !== EBuySellFlag.BUY.toLowerCase()
                                    ? [
                                        {
                                            label: "Payment Mode",
                                            value: (_19 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.payment_mode) !== null && _19 !== void 0 ? _19 : "-",
                                            valueClassName: "DMSanN_14_400",
                                        },
                                    ]
                                    : [])), false), [
                                    {
                                        label: "Bank Name",
                                        value: (_20 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_name) !== null && _20 !== void 0 ? _20 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    {
                                        label: "Account Number",
                                        value: (_21 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.bank_ac_no) !== null && _21 !== void 0 ? _21 : "-",
                                    },
                                ], false),
                            },
                            {
                                section: "Depository Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-depository-details d-flex" })))),
                                data: [
                                    {
                                        label: "DP Name",
                                        value: (_22 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_name) !== null && _22 !== void 0 ? _22 : "-",
                                        valueClassName: "DMSanN_14_400",
                                    },
                                    { label: "DP ID", value: (_23 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.dp_id) !== null && _23 !== void 0 ? _23 : "-" },
                                ],
                            },
                            {
                                section: "Other Details",
                                icon: (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "icon" },
                                        React.createElement("i", { className: "edel-icon-other-detail d-flex" })))),
                                data: [
                                    {
                                        label: "SB Name/Passout",
                                        value: "".concat((_24 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.sb_name) !== null && _24 !== void 0 ? _24 : "-", "/").concat((_25 = orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) !== null && _25 !== void 0 ? _25 : "-"),
                                        valueClassName: "DMSanN_14_400",
                                    },
                                ],
                            },
                        ],
                    };
            }
        }
    };
    return (React.createElement("div", { className: "aif-pms-sidebar-body" },
        React.createElement("div", { className: "custom-tabs-container" },
            React.createElement("div", { className: "auto-height otc-product-bouquet-wrapper width-375 position-relative order-book-accordion" },
                React.createElement("div", { className: "accordion-details mt-2 otc-orderbook-accordion" },
                    React.createElement(SidebarBodyAccordion, { orderDetails: (_b = orderDetailsData(subCategory)) === null || _b === void 0 ? void 0 : _b.orderDetails }))))));
};
export default OrderDetails;
